import styled, { withTheme } from 'styled-components';

const TextUpper = styled.span`
    text-transform: uppercase;

`;

export default withTheme(TextUpper);
